<template>
  <div class="Home">
    <van-image class="img-block" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/img1.png" fit="fill" lazy-load show-loading />
    <div class="center-region">
      <div class="swiper">
        <div class="complete">已成交</div>
        <van-swipe style="height: 45px; line-height: 45px" vertical :show-indicators="false" autoplay="3000">
          <van-swipe-item v-for="(item, index) in noticeList" :key="index">
            <div class="swiper-notice">{{ item }}</div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="middle-content">
        <van-image class="img-block" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/img2.png" fit="fill" lazy-load show-loading />
        <span class="number">已有{{ number }}人提交了卖车申请</span>
        <div class="content">
          <van-cell
            title="设备信息"
            required
            is-link
            :value="infoData ? infoData : '请选择'"
            :value-class="infoData ? 'selected' : ''"
            @click="onInfo"
          />
          <van-cell
            title="出厂年份"
            required
            is-link
            :value="manufactureYear ? manufactureYear : '请选择'"
            :value-class="manufactureYear ? 'selected' : ''"
            @click="onYear"
          />
          <van-cell
            title="所在地区"
            required
            is-link
            :value="areaData ? areaData : '请选择'"
            :value-class="areaData ? 'selected' : ''"
            @click="onRegion"
          />
          <van-field label="表显小时数" v-model="workingHours" type="digit" required input-align="right" placeholder="请填写整数">
            <template #extra>
              <p style="margin-left: 5px">时</p>
            </template>
          </van-field>
          <van-field label="心理价" v-model="psychologicalPrice" type="number" required input-align="right" placeholder="设备心里价格">
            <template #extra>
              <p style="margin-left: 5px">万元</p>
            </template>
          </van-field>
          <van-field label="您的姓名" v-model="userName" required input-align="right" placeholder="请填写您的姓名" />
          <van-field label="联系方式" v-model="userPhone" type="tel" required input-align="right" placeholder="请填写您的联系方式" />
          <van-button type="primary" color="#ffd23c" class="btn-style" @click.native="onClueAdd" block>提交申请</van-button>
        </div>
      </div>
      <van-image class="imgSrc" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/img3.png" fit="fill" lazy-load show-loading />
      <van-image class="imgSrc" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/img4.png" fit="fill" lazy-load show-loading />
      <van-image
        class="imgSrc"
        :src="
          clueSourceType == 'wx'
            ? 'https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/img5.png'
            : 'https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/img6.png'
        "
        fit="fill"
        lazy-load
        show-loading
      />
    </div>
    <van-popup v-model="infoShow" round position="bottom">
      <van-picker show-toolbar title="设备信息" :columns="infoList" @confirm="onConfirmInfo" @cancel="onCancelInfo" />
    </van-popup>
    <van-popup v-model="yearShow" round position="bottom">
      <van-picker show-toolbar title="出厂年份" :columns="columnsYear" @confirm="onConfirmYear" @cancel="onCancelYear" />
    </van-popup>
    <van-popup v-model="regionShow" round position="bottom">
      <van-picker show-toolbar title="省市区" :columns="areaList" @confirm="onConfirmRegion" @cancel="onCancelRegion" />
    </van-popup>
  </div>
</template>
<script>
import { province } from "@/utils/address"
export default {
  name: "Home",
  components: {},
  data() {
    return {
      infoShow: false, //设备信息
      yearShow: false, //出厂年份
      regionShow: false, //所在地区
      manufactureYear: "", //出厂年份数据
      columnsYear: [], //出厂年份列表
      noticeList: [], //成交喜报
      infoList: [], //设备信息列表
      infoData: "", //设备信息数据
      areaList: [], //省市区列表
      areaData: "", //省市区数据
      workingHours: "", //小时数
      psychologicalPrice: "", //心理价
      userName: "", //姓名
      userPhone: "", //手机号
      typeName: "", //类型名称
      brandName: "", //品牌名称
      modelName: "", //型号名称
      provinceName: "", //省
      cityName: "", //市
      districtName: "", //区
      number: 3000, //提交次数
      clueSourceType: "wx" //默认微信打开
    }
  },
  created() {
    this.clueSourceType = this.$route.query.type || "wx"
    this.getClueCisit() //提交次数
    this.getYearsToNow() //出厂年份
    this.getNoticeList() //成交喜报
    this.getBrandModelList() //设备信息
    this.areaList = province //省市区
  },
  methods: {
    onInfo() {
      this.infoShow = true //设备信息
    },
    onConfirmInfo(value) {
      this.typeName = value[0]
      this.brandName = value[1]
      this.modelName = value[2]
      this.infoData = value[0] + value[1] + value[2]
      this.infoShow = false
    },
    onCancelInfo() {
      this.infoShow = false
    },
    onYear() {
      this.yearShow = true //出厂年份
    },
    onConfirmYear(value) {
      this.manufactureYear = value
      this.yearShow = false
    },
    onCancelYear() {
      this.yearShow = false
    },
    onRegion() {
      this.regionShow = true //所在地区
    },
    onConfirmRegion(value) {
      this.provinceName = value[0]
      this.cityName = value[1]
      this.districtName = value[2]
      this.areaData = value[0] + value[1] + value[2]
      this.regionShow = false
    },
    onCancelRegion() {
      this.regionShow = false
    },
    getYearsToNow() {
      //获取到从1987那一年开始至今的年份
      let smallYears = 1987 //获取到从那一年开始
      let date = new Date() //获取当前时间
      let nowYears = date.getFullYear()
      let Years = nowYears - smallYears
      let arrYear = []
      for (let i = 0; i <= Years; i++) {
        arrYear.push(nowYears--)
      }
      arrYear.unshift("不详")
      this.columnsYear = arrYear
    },
    onClueAdd() {
      let clueSource = this.$route.query.clueSource //渠道值
      let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      let userReg = /\/|\~|\!|\@|\#|\$|\%|\^|\&|\*|\/|\'|\|-|\=|\|\s+/
      let priceReg = /^[0-9]+(.[0-9]{1})?$/
      if (this.infoData == "") {
        this.$toast({ message: "请选择设备信息", position: "bottom" })
        return
      }
      if (this.manufactureYear == "") {
        this.$toast({ message: "请选择出厂年份", position: "bottom" })
        return
      }
      if (this.areaData == "") {
        this.$toast({ message: "请选择所在地区", position: "bottom" })
        return
      }
      if (this.workingHours == "") {
        this.$toast({ message: "请填写设备小时数", position: "bottom" })
        return
      }
      if (this.psychologicalPrice == "") {
        this.$toast({ message: "请填写心理价", position: "bottom" })
        return
      }
      if (this.userName == "") {
        this.$toast({ message: "请填写您的姓名", position: "bottom" })
        return
      }
      if (this.userPhone == "") {
        this.$toast({ message: "请填写您的联系方式", position: "bottom" })
        return
      }
      if (!priceReg.test(this.psychologicalPrice)) {
        this.$toast({ message: "心理价保留一位小时，请修改心理价~", position: "bottom" })
        return
      }
      if (this.psychologicalPrice > 9999) {
        this.$toast({ message: "最大心理价为9999万元，请修改心理价~", position: "bottom" })
        return
      }
      if (userReg.test(this.userName)) {
        this.$toast({ message: "姓名不能包含特殊字符", position: "bottom" })
        return
      }
      if (!phoneReg.test(this.userPhone)) {
        this.$toast({ message: "输入手机号有误", position: "bottom" })
        return
      }
      let params = {
        clueSource, //渠道参数
        typeName: this.typeName, //类型名称
        brandName: this.brandName, //品牌名称
        modelName: this.modelName, //型号名称
        manufactureYear: this.manufactureYear, //出厂年份
        provinceName: this.provinceName, //省
        cityName: this.cityName, //市
        districtName: this.districtName, //区
        workingHours: this.workingHours, //小时数
        psychologicalPrice: this.psychologicalPrice, //心理价
        userName: this.userName, //姓名
        userPhone: this.userPhone //联系方式
      }
      this.$api.clueAdd({ ...params }).then((res) => {
        if (res.data.code == 0) {
          this.$toast({ message: "您已成交提交申请，随后我们的专业经纪人会与您联系，请保持电话畅通~", position: "bottom" })
          this.infoData = ""
          this.manufactureYear = ""
          this.areaData = ""
          this.workingHours = ""
          this.psychologicalPrice = ""
          this.userName = ""
          this.userPhone = ""
        }
      })
    },
    getNoticeList() {
      this.$api.getNotice({}).then((res) => {
        this.noticeList = res.data.data
      })
    },
    getBrandModelList() {
      this.$api.brandModelList({ includeType: true }).then((res) => {
        this.infoList = res.data.data.children
      })
    },
    getClueCisit() {
      this.$api.clueCisit({}).then((res) => {
        this.number = res.data.data ? res.data.data.totalClueCount : 3000
      })
    }
  },
  watch: {}
}
</script>
<style lang="scss">
.Home {
  .van-cell {
    background: #ffffff;
    margin-top: 0;
  }
  .van-cell__title {
    flex: 0.4;
  }
  .van-field__label {
    color: #323233;
  }
  .selected {
    color: #323233;
  }
}
</style>
<style lang="scss" scoped>
.Home {
  width: 375px;
  height: 100%;
  padding-bottom: 19px;
  background: #f8f2df;
  .center-region {
    padding: 0 17px;
    box-sizing: border-box;
    .swiper {
      width: 100%;
      height: 45px;
      background: #ffffff;
      border-radius: 21px;
      display: flex;
      align-items: center;
      padding: 0 18px;
      box-sizing: border-box;
      margin-top: 5px;
      .complete {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #fb463f;
        flex-shrink: 0;
        margin-right: 12px;
      }
      .swiper-notice {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .middle-content {
      margin-top: 10px;
      position: relative;
      .number {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #df6517;
        position: absolute;
        top: 10px;
        left: 157px;
      }
      .content {
        padding: 17px 0;
        background: #ffffff;
        border-bottom-left-radius: 21px;
        border-bottom-right-radius: 21px;
        .btn-style {
          width: 243px;
          height: 52px;
          background: #ffd23c;
          border-radius: 26px;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #121212 !important;
          margin-left: 49px;
          margin-top: 17px;
        }
      }
    }
  }
  .img-block {
    display: block;
  }
  .imgSrc {
    margin-top: 10px;
  }
}
</style>
